<template>
  <v-list density="comfortable" bg-color="transparent" nav>
    <v-list-subheader v-if="title">{{ title }}</v-list-subheader>

    <v-list-item
      v-for="link in links"
      :key="link.route"
      :prepend-icon="link.icon"
      :title="link.name"
      :to="link.path"
      :rounded="UI.BORDER_RADIUS"
    />
  </v-list>
</template>

<script lang="ts" setup>
import { type NavigationLink } from '@/components/navigation/constants/NAVIGATION';
import { UI } from '@/layouts/constants/Layout';

type Props = {
  title?: string;
  links: NavigationLink[];
};

defineProps<Props>();
</script>
